/* eslint-disable react/no-array-index-key */
import React, { Fragment } from 'react';
import { Message } from '@getro/rombo';
import { Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { openChat } from '../../../helpers/supportChat';

export const OAuthMessageError = ({ oAuthError, email, ...rest }) => (
  <Message
    {...rest}
    type="error"
    content={
      oAuthError?.status === 401 ? (
        <>
          {[
            'auth.no_account_associated_with_linkedin_account',
            'auth.no_account_associated_with_google_account',
          ].includes(oAuthError.data?.code) ? (
            <>
              <Text fontSize="14px">
                {`This invite is for ${email}, but your ${
                  oAuthError.provider === 'linkedin' ? 'LinkedIn' : 'Google'
                } is linked to ${oAuthError.data?.data?.email}.`}
              </Text>
              <Text fontSize="14px" mt="8px">
                {`To continue, use ${
                  oAuthError.provider === 'linkedin' ? 'LinkedIn' : 'Google'
                } with ${email} or continue with email to set a password.`}
              </Text>
            </>
          ) : (
            oAuthError.data?.error?.split('\n').map((line, index) => (
              <Fragment key={`error-${index}`}>
                {line}
                <br />
              </Fragment>
            ))
          )}
        </>
      ) : (
        <Text>
          There was an unexpected error, please try again or{' '}
          <Text as="span" sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={openChat}>
            contact us
          </Text>
          .
        </Text>
      )
    }
  />
);

OAuthMessageError.propTypes = {
  oAuthError: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
};
